const n = {
  name: "Andorra",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18 1.58582L22 5.58582V22H2V17.5858L4.58579 15H6V13.382L11 10.882L14 12.382V5.58582L18 1.58582ZM8 14.6181L8 20H14V14.6181L11 13.1181L8 14.6181ZM6 20L6 17H5.41421L4 18.4142V20H6ZM16 6.41424V20H20V6.41424L18 4.41424L16 6.41424Z" fill="currentColor"/>
</svg>
  `
};
export {
  n as Andorra
};
